"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Identication"));
__export(require("./Program"));
__export(require("./ProgramEdit"));
__export(require("./financial"));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9pbnRlbGxpdGVjL0Vucm9sbG1lbnRBZ3JlZW1lbnQvQ29tbW9uL3BhcnRzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsb0NBQThCO0FBQzlCLCtCQUF5QjtBQUN6QixtQ0FBNkI7QUFDN0IsaUNBQTJCIn0=